import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

import { ServerUrls } from './../classes/ServerUrls';
import 'rxjs/add/operator/map';
import { ServerResponse } from './../classes/ServerResponse';
import { ServerCalls } from './../classes/ServerCalls';
import { Http, Response, Headers, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';


declare var bootbox:any;

@Injectable()
export class LSServerService {
    public headers: Headers;
    public httpClient: Http;
    public token: string = "";

    constructor(private http:Http, private router:Router) {
        this.httpClient = http;
        this.headers = new Headers({ 'Content-Type': 'application/json', 
                                     'Accept': 'q=0.8;application/json;q=0.9' });
        
    }

    get(url: string, options?: RequestOptions) : Observable<ServerResponse> {
        //if(options!=null) {
            //options.headers = this.headers;
        //}
        return this.http
            .get(url)
            .map(this.extractData)
            .map((res: ServerResponse) => {
                if (!res.status) {
                    bootbox.alert(res.message);
                }
                return res;
            })
	        .catch(this.handleErrorObservable);
    }

    post(url: string, data: any, options?: RequestOptions) : Observable<ServerResponse> {
        //if(options!=null) {
            //options.headers = this.headers;
        //}
        return this.http
            .post(url, data, options)
            .map(this.extractData)
            .map((res: ServerResponse) => {
                if (!res.status) {
                    if(res.message.toLowerCase().indexOf('authorization failed')>-1) {
                        localStorage.clear();
                        this.router.navigate(['/admin/login'],{queryParams:{"msg":"login required to continue.","r":this.router.url}});
                    }
                    else {
                        bootbox.alert(res.message);
                    }
                }
                return res;
            })
            .catch(this.handleErrorObservable)
            .finally((() => {
                this.hideThrobber();
            }));
    }

    private showThrobber() {

    }

    private hideThrobber() {
        
    }

    private handleErrorObservable (error: Response | any) {
        console.error(error.message || error);
        var e = error.message || error;
        console.log(e.statusText);
        //bootbox.alert("Error Occured: " + e.statusText);
        return Observable.throw(error.message || error);
    } 

    private handleErrorPromise (error: Response | any) {
        console.error(error.message || error);
        var e = error.message || error;
        console.log(e.statusText);
        //bootbox.alert("Error Occured: " + e.statusText);
        return Promise.reject(error.message || error);
    }

    private extractData(res: Response) {
        try {
            let body = res.json();
            return body;
        }
        catch(ex) {
            bootbox.alert("Error: " + ex);
        }
    } 



}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/services/LSServer.service.ts